/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_UniqueInputs */

const en_admin_funnel_footnote_unique = /** @type {(inputs: Admin_Funnel_Footnote_UniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every step counts unique visitors (hl_did cookie), not impressions; percentages under each step are relative to visitors in the same row. The daily table de-duplicates within each UTC+8 day.`)
};

/**
* | output |
* | --- |
* | "Every step counts unique visitors (hl_did cookie), not impressions; percentages under each step are relative to visitors in the same row. The daily table de-..." |
*
* @param {Admin_Funnel_Footnote_UniqueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_unique = /** @type {((inputs?: Admin_Funnel_Footnote_UniqueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_UniqueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_unique(inputs)
});
export { admin_funnel_footnote_unique as "admin.funnel.footnote.unique" }